import { OverlayModal } from '@hive/component';
import { useI18n } from '@hive/i18n';

export const StarHiveModal = ({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
}) => {
  const t = useI18n();

  return (
    <OverlayModal
      open={open}
      topImage={
        <video
          width={400}
          height={300}
          style={{ objectFit: 'cover' }}
          src={'/static/githubStar.mp4'}
          autoPlay
          loop
        />
      }
      title={t['com.hive.star-hive.title']()}
      onOpenChange={setOpen}
      description={t['com.hive.star-hive.description']()}
      cancelText={t['com.hive.star-hive.cancel']()}
      to={BUILD_CONFIG.githubUrl}
      confirmButtonOptions={{
        variant: 'primary',
      }}
      confirmText={t['com.hive.star-hive.confirm']()}
      external
    />
  );
};
